enum BreakpointEnum {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl',
}

export default BreakpointEnum;
